module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-get-virtual"
  }, [_c('Title', {
    attrs: {
      "props": _vm.props
    }
  }), _c('div', {
    staticClass: "custom-get-virtual__sub-title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.sub_title)
    }
  }), _c('div', {
    staticClass: "custom-get-virtual__container"
  }, _vm._l((_vm.props.tiles), function(tile, i) {
    return _c('div', {
      staticClass: "custom-get-virtual__tile"
    }, [(tile.image) ? _c('div', {
      staticClass: "custom-get-virtual__tile-image",
      style: ({
        backgroundImage: 'url(' + tile.image + ')'
      })
    }) : _vm._e(), _c('div', {
      staticClass: "custom-get-virtual__tile-title",
      domProps: {
        "innerHTML": _vm._s(tile.title)
      }
    }), _c('div', {
      staticClass: "custom-get-virtual__tile-body",
      domProps: {
        "innerHTML": _vm._s(tile.body)
      }
    })])
  })), _c('center', [_c('iframe', {
    attrs: {
      "width": "560",
      "height": "315",
      "src": "https://www.youtube.com/embed/TY1F9aluuK4",
      "frameborder": "0",
      "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
      "allowfullscreen": "allowfullscreen"
    }
  })]), _c('VirtualForm')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb43d828","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-get-virtual/custom-get-virtual.pug
// module id = 1145
// module chunks = 1